import {ChangeDetectorRef, Component, Input, ViewEncapsulation} from '@angular/core';
import { FamilyRoomDirectoryService } from "@services/family-room-directory.service";

@Component({
  selector: 'family-room-directory-upload',
  templateUrl: './family-room-directory-upload.component.html',
  styleUrls: ['./family-room-directory-upload.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FamilyRoomDirectoryUploadComponent {
  @Input('person') person;

  file: File | null = null;

  previewUrl: string | ArrayBuffer;

  readonly baseURL = 'https://';

  constructor(protected cdr: ChangeDetectorRef, protected familyRoomDirectoryService: FamilyRoomDirectoryService) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    this.setFile(input.files[0]);
  }

  deleteImage(event) {
    this.person.imageUrl = null;
    this.person.imageFileName = null;
    this.previewUrl = null;
    event.stopPropagation();
    event.preventDefault();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (!event.dataTransfer?.files?.length) return;
    this.setFile(event.dataTransfer.files[0]);
  }

  private setFile(file: File) {
    this.file = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
      this.familyRoomDirectoryService.uploadFile(file).subscribe((data) => {
        if (data?.message == "File uploaded successfully") {
          this.person.imageUrl = data.fileName;
          this.person.imageFileName = data.fileName;
        }
      });
      this.cdr.markForCheck();
    };
    reader.readAsDataURL(file);
  }
}
